import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import ThreeQuestions from "@/components/sections/ThreeQuestions";
import BeforeAfter from "@/components/sections/BeforeAfter";
import Method from "@/components/sections/Method";
import Partnerships from "@/components/sections/Partnerships";
import Differentiators from "@/components/sections/Differentiators";
import Sectors from "@/components/sections/Sectors";
import Team from "@/components/sections/Team";
import BlackCTA from "@/components/sections/BlackCTA";

export default function Home() {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;
        const id = hash.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
            setTimeout(() => {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 60);
        }
    }, [hash]);

    return (
        <main data-testid="home-page" className="bg-white">
            <Navigation />
            <Hero />
            <ThreeQuestions />
            <BeforeAfter />
            <Method />
            <Partnerships />
            <Differentiators />
            <Sectors />
            <Team />
            <BlackCTA />
            <Footer />
        </main>
    );
}
